import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Loader } from '@els/els-react--loader';
import { commaFormatNumber } from '@Utils/String';
import RsSlidable, { CONTROLS_PLACEMENTS } from '@Pages/RetroSynthesis/components/RsSlidable/RsSlidable';
import { LEYDEN_TAB_GROUP_CLASSES } from '@Containers/ResultToolbar/DatabaseSwitcher/LeydenClasses';

import './DatabaseSwitcherTabs.scss';

function DatabaseSwitcherTabGroup({ className, currentDatabase, isDbSwitcherVisible, availableDatabases, selectDatabase }) {
  const tabsRenderer = (item) => (
    <button
      disabled={!item.count}
      type="button"
      className={cn(LEYDEN_TAB_GROUP_CLASSES.tabGroupItem, LEYDEN_TAB_GROUP_CLASSES.tabGroupText, {
        [LEYDEN_TAB_GROUP_CLASSES.tabGroupItemActive]: item.databaseId === currentDatabase.databaseId,
        [LEYDEN_TAB_GROUP_CLASSES.tabGroupItemDisabled]: !item.count,
      })}
      onClick={() => {
        selectDatabase(item);
      }}
      data-e2e="database-switcher-tab">
      <span className="database-switcher-new__tab-content">
        {item.title}
        {/* eslint-disable-next-line no-nested-ternary */}
        {item.isLoading ? (
          <Loader isSmall isBlocking={false} className="database-switcher-new__tab-loader" />
        ) : item.canceled ? (
          'canceled'
        ) : (
          commaFormatNumber(item.count)
        )}
      </span>
    </button>
  );

  const currentTabIndex = useMemo(
    () => currentDatabase && availableDatabases.findIndex(({ databaseId }) => databaseId === currentDatabase.databaseId),
    [availableDatabases, currentDatabase]
  );

  const contentAttrs = {
    role: 'tablist',
    'aria-label': 'tabs',
  };
  const itemAttrs = ({ databaseId, context }) => ({
    id: `databases-tab-${context}-${databaseId}`,
    role: 'tab',
    'aria-selected': databaseId === currentDatabase.databaseId,
    'aria-controls': `results-tabpanel-${context}-${databaseId}`,
  });

  return isDbSwitcherVisible ? (
    <div className={cn('database-switcher-new', 'u-els-padding-top-1o2', className)}>
      <RsSlidable
        className="database-switcher-new__slidable rx-flex-1"
        containerClassName={cn('database-switcher-new__list-container', LEYDEN_TAB_GROUP_CLASSES.tabGroup)}
        contentClassName={cn(LEYDEN_TAB_GROUP_CLASSES.tabGroup, LEYDEN_TAB_GROUP_CLASSES.tabGroupDivider)}
        contentAttrs={contentAttrs}
        itemAttrs={itemAttrs}
        items={availableDatabases}
        renderItem={tabsRenderer}
        visibleItemIndex={currentTabIndex}
        controlsPlacement={CONTROLS_PLACEMENTS.bothSides}
      />
    </div>
  ) : null;
}

DatabaseSwitcherTabGroup.propTypes = {
  className: PropTypes.string,
  currentDatabase: PropTypes.object,
  isDbSwitcherVisible: PropTypes.bool,
  selectDatabase: PropTypes.func,
  availableDatabases: PropTypes.array,
};

export default DatabaseSwitcherTabGroup;
